import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";
import { Reveal, SectionHeading, EASE } from "./Reveal";

export const FaqSection = ({ data }) => {
    const [open, setOpen] = useState(0);
    return (
        <section id="faq" className="py-16 sm:py-20">
            <SectionHeading eyebrow="Still curious" title={data.title} intro={data.intro} />
            <div className="mt-10 divide-y divide-[#E4DFD3] border-y border-[#E4DFD3]">
                {data.items.map((item, i) => {
                    const isOpen = open === i;
                    return (
                        <Reveal key={i} delay={i * 0.06}>
                            <div>
                                <button
                                    data-testid={`faq-question-${i + 1}`}
                                    onClick={() => setOpen(isOpen ? -1 : i)}
                                    className="group flex w-full items-center justify-between gap-4 py-5 text-left"
                                >
                                    <span className={`font-serif text-base sm:text-lg font-medium transition-colors ${isOpen ? "text-[#576856]" : "text-[#1A1D1A] group-hover:text-[#576856]"}`}>
                                        {item.q}
                                    </span>
                                    <motion.span
                                        animate={{ rotate: isOpen ? 45 : 0 }}
                                        transition={{ duration: 0.3, ease: EASE }}
                                        className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full border transition-colors ${
                                            isOpen ? "border-[#576856] bg-[#576856] text-white" : "border-[#C4BCA8] text-[#576856]"
                                        }`}
                                    >
                                        <Plus size={15} strokeWidth={1.8} />
                                    </motion.span>
                                </button>
                                <AnimatePresence initial={false}>
                                    {isOpen && (
                                        <motion.div
                                            initial={{ height: 0, opacity: 0 }}
                                            animate={{ height: "auto", opacity: 1 }}
                                            exit={{ height: 0, opacity: 0 }}
                                            transition={{ duration: 0.4, ease: EASE }}
                                            className="overflow-hidden"
                                        >
                                            <p data-testid={`faq-answer-${i + 1}`} className="pb-6 pr-12 text-sm leading-relaxed text-[#6D736D]">
                                                {item.a}
                                            </p>
                                        </motion.div>
                                    )}
                                </AnimatePresence>
                            </div>
                        </Reveal>
                    );
                })}
            </div>
        </section>
    );
};
